import React from "react";
import { useTranslation } from "react-i18next";
import style from "../partnerProfileModal.module.scss";

const PartnerMainInfo = ({ item }) => {
  const { t } = useTranslation();

  const formatPhone = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (match) {
      return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`;
    }
    return phone;
  };

  return (
    <div className={style.mainInfo}>
      <div className={style.sectionHeader}>
        <h3>{t("partnerProfile.mainInfo.title")}</h3>
      </div>

      <div className={style.infoGrid}>
        <div className={style.infoField}>
          <div className={style.label}>{t("partnersPage.table.companyName")}</div>
          <div className={style.companyName}>{item.companyName || "-"}</div>
        </div>
        <div className={style.infoField}>
          <div className={style.label}>{t("partnerProfile.mainInfo.fields.bin")}</div>
          <div className={style.value}>{item.bin || "-"}</div>
        </div>
        {/* <div className={style.infoField}>
          <div className={style.label}>{t("partnerProfile.mainInfo.fields.fullName")}</div>
          <div className={style.value}>
            {item.headUser.surname || ''}{' '}
            {item.headUser.name || ''}{' '}
            {item.headUser.patronymic || ''}
          </div>
        </div>
        <div className={style.infoField}>
          <div className={style.label}>{t("partnerProfile.mainInfo.fields.phone")}</div>
          <div className={style.value}>{formatPhone(item.headUser?.phoneNumber) || "-"}</div>
        </div>
        <div className={style.infoField}>
          <div className={style.label}>{t("partnerProfile.mainInfo.fields.email")}</div>
          <div className={style.value}>{item.headUser?.email || "-"}</div>
        </div> */}
      </div>
    </div>
  );
};

export default PartnerMainInfo;
